
export const portfoliostyle = {
  deletewrap: {
    position: "absolute",
    top: "10px",
    right: "10px",
    padding:"10px",
    borderRadius:"50%",
    height:40,
    width:40,
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    cursor:"pointer"
  },
};
